import React from 'react';
import { createRoot } from 'react-dom/client';
import CustomSelect from './custom-select';
import './css/index.css';

export default class {

    static name = 'custom-select';

    constructor( config ) {

        this.wrapper = config.element;
        this.attributes = config.attributes;

        this.root = createRoot( this.wrapper );

    }

    ready() {

        this.root.render(
            <CustomSelect
                attributes={ this.attributes }
            />,
        );

    }

}
